import { render, staticRenderFns } from "./InstanceList.vue?vue&type=template&id=70c03e12&scoped=true&"
import script from "./InstanceList.vue?vue&type=script&lang=js&"
export * from "./InstanceList.vue?vue&type=script&lang=js&"
import style0 from "./InstanceList.vue?vue&type=style&index=0&id=70c03e12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c03e12",
  null
  
)

export default component.exports